import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { Suspense, lazy, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import noop from '../utils/noop';
import retry from '../utils/webpack/chunkRetry';
const Editor = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "editor", webpackPrefetch: true */ './DaEditorWrapper.container')));
export const LoadableDaEditorWrapper = (_param)=>{
    var { staticComponent: StaticComponent, loadingComponent: LoadingComponent, forceLoadOnMount, onStaticComponentClick = noop } = _param, rest = _object_without_properties(_param, [
        "staticComponent",
        "loadingComponent",
        "forceLoadOnMount",
        "onStaticComponentClick"
    ]);
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [mounted, setMounted] = useState(false);
    const staticWrapperRef = useRef(null);
    useEffect(()=>{
        setMounted(true);
        // When something is dragged into the static wrapper, load the editor.
        // This is so we don't lose files dragged into lazy unloaded editors.
        const staticWrapperEl = staticWrapperRef.current;
        if (staticWrapperEl) {
            staticWrapperEl.addEventListener('dragenter', ()=>{
                setShow(true);
            });
        }
    }, []);
    const handleClick = ()=>{
        setShow(true);
        onStaticComponentClick();
    };
    if (!show && StaticComponent && !forceLoadOnMount) {
        return /*#__PURE__*/ React.createElement("div", {
            role: "button",
            "aria-label": t('commentbox.editor.trigger'),
            tabIndex: 0,
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
                    handleClick();
                    e.preventDefault();
                }
            },
            onClick: handleClick,
            ref: staticWrapperRef
        }, /*#__PURE__*/ React.createElement(StaticComponent, null));
    }
    const waitForMount = typeof window === 'undefined' && !mounted;
    if (!StaticComponent && waitForMount) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableDaEditorWrapper"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingComponent, null)
    }, /*#__PURE__*/ React.createElement(Editor, rest)));
};
LoadableDaEditorWrapper.displayName = 'LoadableDaEditorWrapper';
export default LoadableDaEditorWrapper;
